
<template>
  <div class="video-container">
    <video 
      :poster="computedPosterSrc"
      @mouseenter="e => {if(!autoplay) {e.target.play()}}" 
      @mouseleave="e => {if(!autoplay) {e.target.pause()}}" 
      :autoplay="autoplay"
      :loop="loop"
      muted
    >
      <source 
        :src="computedSrc"  
        type="video/mp4"
      />
      <img 
        :src="computedSrc" 
        :srcset="computedSrcset"
        :sizes="sizes"

        :alt="alt" 
        :width="width" 
        :height="height"
      >        
    </video>
  </div>
</template>

<script>
export default {
  name: 'ResponsiveVideo',
  props: {
    width: Number,
    height: Number,
    ratio: {
      type: Number,
      default: 16/9, 
    }, 
    src: String,
    alt: String,
    isResponsive: Boolean,
    sizes: String,
    isLazy: {
      type: Boolean,
      default: true
    },
    placeholderSrc: String, 
    fadeIn: Boolean, 
    fadeDelay: Number,
    enter: {
      type: Boolean,
      default: true
    },
    autoplay: Boolean,
    loop: Boolean,
    poster: Object,
  },
  data() {
    return {
      loaded: false,
      mounted: false, 
    }
  },
  // watch: {
  //   shouldPlay(bool) {
  //     if(bool) {
  //       this.$refs.videoElem.play()
  //     } else {
  //       this.$refs.videoElem.pause()        
  //     }
  //   }
  // },
  computed: {
    isVisible() {
      return this.isLazy; 
    },
    computedSrc() {
      return require(`../assets${this.src}`);
    },
    computedPosterSrc() {
      return this.poster && this.poster.src ? require(`../assets${this.poster.src}`) : require(`../assets${this.src}?t=1`)
    },
    computedSrcset() {
      return null //this.responsiveImage.src || require(`../assets${this.src}`);
    }
  },
  mounted() {
    this.mounted = true
  },
}
</script>

<style lang="sass" scoped>

/////////////////////////////////////////////
// 
// Responsive Image
// 
/////////////////////////////////////////////

.video-container
  // +aspect-ratio

  // .lazy-placeholder
  //   position: absolute
  //   top: 50%
  //   left: 50%
  //   transform: translate(-50%, -50%)
  //   min-width: 100%
  //   min-height: 100%

  video
    width: 100%
    // position: absolute
    // top: 50%
    // left: 50%
    // transform: translate(-50%, -50%)
    // height: 100%

.fade-enter-active, .fade-leave-active
  transition: opacity 0.8s ease-in 3s

.fade-enter, .fade-leave-to   
  opacity: 0
</style>
